// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1FE9G","container_1":"container_1___1bywV","container_2":"container_2___1mkP5"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Store/styles.module.scss
// module id = 409
// module chunks = 0